function check_if_map_page() {
  return window.location.pathname.includes('/contact');
}

function get_place_id_from_store_name(storeName) {
  const map = {
    "My Dream Cake - Hallam": "ChIJbddigtYW1moRQVc7feuUzfk",
    "My Dream Cake - Pakenham": "ChIJo4F08aMf1moRVyPjSoYcKpU",
    "My Dream Cake - Sunshine": "ChIJVWt_xthf1moRP1o65l4oXI0"
  };

  const normalizedInput = storeName.replace(/–/g, '-').replace(/\s+/g, ' ').trim();

  for (let key in map) {
    const normalizedKey = key.replace(/–/g, '-').replace(/\s+/g, ' ').trim();

    if (normalizedInput === normalizedKey) {
      return map[key];
    }
  }

  for (let key in map) {
    const normalizedKey = key.replace(/–/g, '-').replace(/\s+/g, ' ').trim();

    if (normalizedInput.includes(normalizedKey)) {
      return map[key];
    }
  }

  return null;
}

function get_default_place_id() {
  return "ChIJbddigtYW1moRQVc7feuUzfk";
}

function inject_reviews_container() {

  if (document.getElementById('google-reviews-section')) {
    return true;
  }

  const target = document.querySelector('.shopify-block.shopify-app-block');

  if (!target) {
    return false;
  }

  const html = `
        <div id="google-reviews-section">

            <div class="reviews-layout">

                <div class="reviews-left">

                    <h3 class="reviews-title">
                        Google Reviews
                    </h3>

                    <div id="reviews-summary">
                        Loading reviews...
                    </div>

                    <div class="reviews-footer">
                        <a id="reviews-link" href="#" target="_blank" rel="noopener noreferrer">
                            VIEW ALL REVIEWS
                        </a>
                    </div>

                </div>

                <div class="reviews-right">

                    <div class="reviews-slider-wrapper">

                        <button class="reviews-prev" aria-label="Previous reviews">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path fill="rgb(71, 71, 71)" d="M201.4 297.4C188.9 309.9 188.9 330.2 201.4 342.7L361.4 502.7C373.9 515.2 394.2 515.2 406.7 502.7C419.2 490.2 419.2 469.9 406.7 457.4L269.3 320L406.6 182.6C419.1 170.1 419.1 149.8 406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3L201.3 297.3z"/></svg>
                        </button>

                        <div class="reviews-track-container">
                            <div id="reviews-list"></div>
                        </div>

                        <button class="reviews-next" aria-label="Next reviews">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path fill="rgb(71, 71, 71)" d="M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z"/></svg>
                        </button>

                    </div>

                </div>

            </div>

        </div>
    `;

  target.insertAdjacentHTML('afterend', html);

  inject_slider_styles();

  return true;
}

function inject_slider_styles() {

  if (document.getElementById('reviews-slider-styles')) {
    return;
  }

  const style = document.createElement('style');

  style.id = 'reviews-slider-styles';

  style.innerHTML = `
.review-stars-wrap {
    display: flex;
    align-items: center;
    gap: 2px;
}

.review-star {
    font-size: 18px;
    line-height: 1;
    color: #d8d8d8;
}

.review-star.filled {
    color: #fbbc04;
}
        #google-reviews-section {
            margin-top: 40px;
            padding: 40px 10px;
            border-top: 1px solid #e5e5e5;
            background: #fff;
            overflow: hidden;
        }

        .reviews-layout {
            display: flex;
            align-items: flex-start;
            gap: 40px;
        }

        .reviews-left {
            width: 260px;
            flex-shrink: 0;
        }

        .reviews-right {
            flex: 1;
            min-width: 0;
        }

        .reviews-title {
            margin: 0 0 24px;
            font-size: 32px;
            line-height: 1.2;
        }

        #reviews-summary {
            margin-bottom: 35px;
        }

        #reviews-summary strong {
            display: inline-block;
            font-size: 52px !important;
            line-height: 1;
            margin-right: 10px;
            font-weight: 700;
        }

        #reviews-summary {
            font-size: 18px;
            color: #444;
        }

        .reviews-slider-wrapper {
            position: relative;
            padding: 0 60px;
        }

        .reviews-track-container {
            overflow: hidden;
            width: 100%;
        }

        #reviews-list {
            display: flex;
            gap: 20px;
            transition: transform 0.35s ease;
            will-change: transform;
            touch-action: pan-y;
            cursor: grab;
            user-select: none;
            padding: 10px 0px;
        }

        #reviews-list.dragging {
            cursor: grabbing;
            transition: none;
        }

        .review-card {
            flex: 0 0 calc((100% - 40px) / 3);
            border: 1px solid #e5e5e5;
            border-radius: 18px;
            padding: 24px;
            background: #fff;
            box-sizing: border-box;
            min-height: 230px;
        }

        .review-card strong {
            display: block;
            margin-bottom: 14px;
            font-size: 22px;
            font-weight: 600;
            color: #222;
            line-height: 1.5;
        }

        .review-rating {
            margin-bottom: 18px;
            font-size: 15px;
            color: #444;
        }

        .review-card p {
            margin: 0;
            font-size: 15px;
            line-height: 1.5;
            color: #555;
        }

        .reviews-prev,
        .reviews-next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            width: 46px;
            height: 46px;
            border: none;
            border-radius: 50%;
            background: #e1e1e1;
            color: #474747;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            transition: opacity 0.2s ease;
        }

        .reviews-prev:hover,
        .reviews-next:hover {
            opacity: 0.85;
        }

        .reviews-prev {
            left: 0;
        }

        .reviews-next {
            right: 0;
        }

        .reviews-footer {
            margin-top: 20px;
        }
.k-popup__loc_panel-item.active {
    background: #e43a8908 !important;
    border-left: 3px solid #e91e63;
}
        @media (max-width: 1200px) {

            .review-card {
                flex: 0 0 calc((100% - 20px) / 2);
            }
        }

        @media (max-width: 991px) {

            .reviews-layout {
                flex-direction: column;
            }

            .reviews-left {
                width: 100%;
            }

            .reviews-right {
                width: 100%;
            }

            .review-card {
                flex: 0 0 calc((100% - 20px) / 2);
            }
        }

        @media (max-width: 767px) {

            #google-reviews-section {
                padding: 17px 10px;
            }

            .reviews-slider-wrapper {
                padding: 0 45px;
            }

            .review-card {
                flex: 0 0 100%;
                min-height: auto;
            }

            .reviews-title {
                font-size: 28px;
            }

            #reviews-summary strong {
                font-size: 42px !important;
            }

            .reviews-prev,
            .reviews-next {
                width: 38px;
                height: 38px;
                font-size: 22px;
            }
            #maps-id-7067 .k-popup__content {
                padding: 0px !important;
            }
            #maps-id-7067 .k-popup__locator-wrap[data-id="TuW6E"] .k-popup__loc_panel {
                height: 250px !important;
            }
        }
    `;

  document.head.appendChild(style);
}

function show_reviews_error() {
  const summary = document.getElementById('reviews-summary');
  const list = document.getElementById('reviews-list');
  const link = document.getElementById('reviews-link');

  if (!summary) {
    return;
  }

  summary.innerHTML = 'Error Loading Reviews';

  if (list) {
    list.innerHTML = '';
  }

  if (link) {
    link.href = '#';
  }
}

function store_click_listener() {

  const interval = setInterval(function () {

    const container = document.querySelector('.k-popup__loc_panel');
    const reviewsReady = inject_reviews_container();

    if (!container || !reviewsReady) {
      return;
    }

    clearInterval(interval);

    container.addEventListener('click', function (e) {

      const item = e.target.closest('.k-popup__loc_panel-item');

      if (!item) {
        return;
      }

      // remove active from all items
      container.querySelectorAll('.k-popup__loc_panel-item').forEach(function(el) {
        el.classList.remove('active');
      });

      // add active to clicked item
      item.classList.add('active');

      const nameEl = item.querySelector('.k-popup_panel__name');

      if (!nameEl) {
        return;
      }

      const storeName = nameEl.innerText.trim();

      const placeId = get_place_id_from_store_name(storeName);

      if (!placeId) {
        show_reviews_error();
        return;
      }

      document.getElementById('reviews-summary').innerHTML = 'Loading reviews...';

      load_google_reviews(placeId);

    });

    // default active first item
    const firstItem = container.querySelector('.k-popup__loc_panel-item');

    if (firstItem) {
      firstItem.classList.add('active');
    }

    load_google_reviews(get_default_place_id());

  }, 500);
}

function load_google_reviews(placeId) {

  if (
    typeof google === 'undefined' ||
    !google.maps ||
    !google.maps.places
  ) {
    show_reviews_error();
    return;
  }

  const mapDiv = document.createElement('div');

  const map = new google.maps.Map(mapDiv);

  const service = new google.maps.places.PlacesService(map);

  service.getDetails(
    {
      placeId: placeId,
      fields: [
        'name',
        'rating',
        'reviews',
        'user_ratings_total'
      ]
    },
    function (place, status) {

      if (
        status !== google.maps.places.PlacesServiceStatus.OK ||
        !place
      ) {
        show_reviews_error();
        return;
      }

      render_reviews(place, placeId);
    }
  );
}

function render_reviews(place, placeId) {

  const summary = document.getElementById('reviews-summary');
  const list = document.getElementById('reviews-list');
  const link = document.getElementById('reviews-link');

  if (!summary || !list || !link) {
    return;
  }

  summary.innerHTML = `
        <strong style="font-size:26px;">
            ${place.rating || 'N/A'}
        </strong>
        ⭐ (${place.user_ratings_total || 0} reviews)
    `;

  list.innerHTML = '';

  (place.reviews || []).slice(0, 10).forEach(function (review) {

    const div = document.createElement('div');

    div.classList.add('review-card');

    div.innerHTML = `
            <strong>${review.author_name}</strong>

            <div class="review-rating">
                ${generate_star_rating(review.rating)}
            </div>

            <p>
                ${(review.text || '').substring(0, 160)}...
            </p>
        `;

    list.appendChild(div);
  });

  link.href = `https://www.google.com/maps/place/?q=place_id:${placeId}`;

  init_reviews_slider();
}

function generate_star_rating(rating) {

  let stars = '';

  for (let i = 1; i <= 5; i++) {

    if (i <= rating) {

      stars += `
                <span class="review-star filled">
                    ★
                </span>
            `;
    }

    else {

      stars += `
                <span class="review-star">
                    ★
                </span>
            `;
    }
  }

  return `
        <div class="review-stars-wrap">
            ${stars}
        </div>
    `;
}

function init_reviews_slider() {

  const slider = document.getElementById('reviews-list');
  const prevBtn = document.querySelector('.reviews-prev');
  const nextBtn = document.querySelector('.reviews-next');

  if (!slider || !prevBtn || !nextBtn) {
    return;
  }

  let currentIndex = 0;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let isDragging = false;

  function getSlidesToShow() {

    if (window.innerWidth <= 767) {
      return 1;
    }

    if (window.innerWidth <= 991) {
      return 2;
    }

    return 3;
  }

  function getCardWidth() {

    const card = slider.querySelector('.review-card');

    if (!card) {
      return 0;
    }

    const gap = 20;

    return card.offsetWidth + gap;
  }

  function updateSlider() {

    const cardWidth = getCardWidth();

    currentTranslate = -(currentIndex * cardWidth);
    prevTranslate = currentTranslate;

    slider.style.transform = `translateX(${currentTranslate}px)`;
  }

  function nextSlide() {

    const cards = slider.querySelectorAll('.review-card');
    const slidesToShow = getSlidesToShow();

    const maxIndex = cards.length - slidesToShow;

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateSlider();
    }
  }

  function prevSlide() {

    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  }

  prevBtn.onclick = prevSlide;
  nextBtn.onclick = nextSlide;

  function touchStart(index) {

    return function (event) {

      currentIndex = index;

      startX = getPositionX(event);

      isDragging = true;

      slider.classList.add('dragging');

      animation();
    };
  }

  function touchMove(event) {

    if (!isDragging) {
      return;
    }

    const currentPosition = getPositionX(event);

    currentTranslate = prevTranslate + currentPosition - startX;

    slider.style.transform = `translateX(${currentTranslate}px)`;
  }

  function touchEnd() {

    cancelAnimationFrame(animationID);

    isDragging = false;

    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -80) {
      nextSlide();
    }

    else if (movedBy > 80) {
      prevSlide();
    }

    else {
      updateSlider();
    }

    slider.classList.remove('dragging');
  }

  function getPositionX(event) {

    return event.type.includes('mouse')
      ? event.pageX
      : event.touches[0].clientX;
  }

  let animationID;

  function animation() {

    slider.style.transform = `translateX(${currentTranslate}px)`;

    if (isDragging) {
      animationID = requestAnimationFrame(animation);
    }
  }

  const cards = slider.querySelectorAll('.review-card');

  cards.forEach((card, index) => {

    card.addEventListener('dragstart', (e) => e.preventDefault());

    card.addEventListener('touchstart', touchStart(index));
    card.addEventListener('touchmove', touchMove);
    card.addEventListener('touchend', touchEnd);

    card.addEventListener('mousedown', touchStart(index));
    card.addEventListener('mousemove', touchMove);
    card.addEventListener('mouseup', touchEnd);
    card.addEventListener('mouseleave', function () {
      if (isDragging) {
        touchEnd();
      }
    });
  });

  window.addEventListener('resize', updateSlider);

  updateSlider();
}

document.addEventListener('DOMContentLoaded', function () {

  if (!check_if_map_page()) {
    return;
  }

  store_click_listener();

});